import React from 'react';
import PropTypes from 'prop-types';
import ScoreCard from './ScoreCard';
import { METRIC_KEYS } from '../Constants';
import './styles/score-category-section.css';

export default function ScoreCategorySection({ items, scores, expandAll, highlightedMetric, nodeType }) {
  if (!scores) return null;
  
  // Function to determine if a specific score key should be highlighted
  const isScoreHighlighted = (scoreKey) => {
    if (!highlightedMetric || highlightedMetric === 'overall') return false;
    
    // Get the actual score key that should be highlighted for this metric and node type
    const targetScoreKey = METRIC_KEYS[highlightedMetric]?.[nodeType];
    return scoreKey === targetScoreKey;
  };
  
  return (
    <div className="scores-grid">
      {items.map(([key, label]) => {
        const val = scores[key];
        if (!val) return null;
        
        return (
          <ScoreCard
            key={key}
            label={label}
            score={val.score}
            explanation={val.explanation}
            suggestions={val.improvementSuggestions}
            expandAll={expandAll}
            isHighlighted={isScoreHighlighted(key)}
            metricKey={key} // NEW: Pass the metric key
          />
        );
      })}
    </div>
  );
}

ScoreCategorySection.propTypes = {
  items: PropTypes.arrayOf(PropTypes.array).isRequired,
  scores: PropTypes.object.isRequired,
  expandAll: PropTypes.bool,
  highlightedMetric: PropTypes.string,
  nodeType: PropTypes.string.isRequired // NEW: need to know the node type
};